import { BvApolloClient } from '@dinosband/bv-apollo-client'

export let apollo: BvApolloClient | undefined

export function setApolloClientForPicture (apolloClient: BvApolloClient) {
  apollo = apolloClient
}